import { initDialogs } from './dialogs.js';
import { initProductForms } from './product-form.js';
import { initCartForms, refreshCart } from './cart.js';
import { initStickyCart } from './sticky-cart.js';
import { initQuickAdd } from './quick-add.js';
import { initInputMode } from './input-mode.js';
import { showAddedToCart } from './added-dialog.js';
import { initNewsletterPopup } from './newsletter-popup.js';
import { flyToCart } from './cart-flight.js';
import { initApplicationGuide } from './application-guide.js';

function initialize(root = document) {
  initProductForms(root);
  initCartForms(root);
  initStickyCart(root);
  initQuickAdd(root);
  initNewsletterPopup(root);
  initApplicationGuide(root);
}

initInputMode();
initDialogs();
initialize();
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('nur:cart-updated', async event => {
  const { opener, added } = event.detail || {};
  if (added) await flyToCart(opener);
  if (added && await showAddedToCart(added, opener)) return;
  refreshCart(opener);
});
document.addEventListener('click', event => {
  const cartLink = event.target.closest('[data-cart-open]');
  if (!cartLink) return;
  event.preventDefault();
  refreshCart(cartLink);
});
